import { TitleAndSubtitleDisplay } from '@/atoms/TitleAndSubtitleDisplay'
import { LinksViewProps } from '@/services/RenderService'
import { LandscapeGrid } from './LandscapeGrid'
import { LargeLandscapeLink } from './LargeLandscapeLink'

export function LargeLandscapeGrid({
  imageWidth = 490,
  imageHeight = 294,
  id,
  links,
  showTitleDescription,
  className,
}: LinksViewProps) {
  return (
    <LandscapeGrid className={className} id={id} data-testid={`large-landscape-grid-${id}`}>
      {links.map((link) => (
        <div className="w-fit max-w-full" key={link.name}>
          <LargeLandscapeLink link={link} imageHeight={imageHeight} imageWidth={imageWidth} />
          {showTitleDescription && (
            <div style={{ maxWidth: `${imageWidth}px` }}>
              <TitleAndSubtitleDisplay className="my-4 w-full" title={link.name} subtitle={link.label} clampSubtitle />
            </div>
          )}
        </div>
      ))}
    </LandscapeGrid>
  )
}
